module.exports = __webpack_public_path__ + "media/images/telekom-4bfa7c7e85f5995e9fc7535556a5dce2.png";